import axios from 'axios'
import { BASE_URL } from './base-url'

var base = BASE_URL;


export default class TeamService {

    createTeam(token, team) {
        return new Promise((done, reject) => {

            var instance = {
                baseURL: base + '/api/teamsvireed',
                method: 'post',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + token
                },
                data: team
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    getTeams(token) {
        return new Promise((done, reject) => {

            var instance = {
                baseURL: base + '/api/teamsvireed',
                method: 'get',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + token
                },
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    deleteTeam(token, teamId) {
        return new Promise((done, reject) => {

            var instance = {
                baseURL: base + '/api/teamsvireed/' + teamId,
                method: 'delete',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + token
                },
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    updateTeam(token, teamId, team) {
        return new Promise((done, reject) => {

            var instance = {
                baseURL: base + '/api/teamsvireed/' + teamId,
                method: 'put',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + token
                },
                data: team
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    getTeam(token, teamId, projectId = undefined) {
        return new Promise((done, reject) => {

            var body = {
                projectId: projectId
            }
            var instance = {
                baseURL: base + '/api/teamsvireed/' + teamId,
                method: 'get',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + token
                },
                params: body,
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

}